import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { DashboardService } from "../../../Component/Api/EmploymentEquity/Dashboard/DashboardService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SortDirections, ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { EEAverageAndMedianRemuneration } from "../../../Component/Model/Dto/EmploymentEquity/AverageAndMedianRemuneration/AverageAndMedianRemuneration";
import { EmploymentEquityDashboardDto } from "../../../Component/Model/Dto/EmploymentEquity/Dashboard";
import { TopAndBottomEarnersTableMapper } from "../../EmploymentEquity/WorkforceProfile_EEA4/AverageAndMedianRemuneration/AverageAndMedianRemunerationTableColumns";
import { getDateWithoutTime } from "../../../Helpers/DateFormatter";

interface IProps {
    remunerationType: number;
    scorecardId: string;
    genderIds: number[];
    occupationIds: number[];
    raceIds: number[];
    sourceScorecardIds?: string[];
}

export const DifferentialDrilldown = (props: IProps) => {
    const [entriesPerPage, setEntriesPerPage] = React.useState(10);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [topOrBottomEarnerData, setTopOrBottomEarnerData] = React.useState<EEAverageAndMedianRemuneration.TopAndBottomEarner[]>([]);
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const [sortColumnName, setSortColumnName] = React.useState<string>('');
    const [sortDirection, setSortDirection] = React.useState<SortDirections>(0);

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setSortColumnName(sortOption.ColumnName);
        setSortDirection(sortOption.SortDirection);
        setPageNumber(1);
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage(entriesPerPage);
        setPageNumber(1);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            var request: EmploymentEquityDashboardDto.IncomeDifferentialsRequest = {
                occupationLevelIds: props.occupationIds ?? [],
                raceIds: props.raceIds ?? [],
                genderIds: props.genderIds ?? [],
                remunerationTypeIds: [props.remunerationType],
                filterDate: getDateWithoutTime(new Date()),
                scorecardId: props.scorecardId,
                sourceScorecardIds: props.sourceScorecardIds,
            }
            let result = await DashboardService.GetIncomeDifferentialPopup(request);
            if (result.data) {
                setTopOrBottomEarnerData(result.data);
                setTotalItemsCount(result.data.length);
                setFilteredItemsCount(result.data.length);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    };

    const indexOfLastPage = pageNumber * entriesPerPage;
    const indexOfFirstPage = indexOfLastPage - entriesPerPage;

    const currentData = topOrBottomEarnerData.slice(
        indexOfFirstPage,
        indexOfLastPage
    );

    const topAndBottomEarnersTableData = TopAndBottomEarnersTableMapper(currentData);

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, sortColumnName, sortDirection]);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} mt={2}>
                <DataTable
                    key={pageNumber}
                    table={topAndBottomEarnersTableData}
                    entriesPerPage={{ defaultValue: entriesPerPage }}
                    pageNumber={pageNumber}
                    filteredItemsCount={filteredItemsCount}
                    totalItemsCount={totalItemsCount}
                    entriesPerPageChanged={entriesPerPageChanged}
                    pageNumberChanged={pageNumberChanged}
                    isLoading={isLoading}
                    manualSorting={true}
                    columnSortingChanged={columnSortingChanged}
                ></DataTable>
            </Grid>
        </Grid>
    )
}
